import * as flatbuffers from 'flatbuffers';
import { createPool } from 'generic-pool';
const poolFactory = {
    async create() {
        return new flatbuffers.Builder(1024 * 1024 * 20);
    },
    /* istanbul ignore next */
    async destroy(builder) {
        builder.clear();
    },
};
const poolOptions = {
    max: 8,
    min: 1,
};
export const builderPool = createPool(poolFactory, poolOptions);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvc2VyaWFsaXphdGlvbi9idWlsZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxXQUFXLE1BQU0sYUFBYSxDQUFBO0FBQzFDLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxjQUFjLENBQUE7QUFFekMsTUFBTSxXQUFXLEdBQUc7SUFDbEIsS0FBSyxDQUFDLE1BQU07UUFDVixPQUFPLElBQUksV0FBVyxDQUFDLE9BQU8sQ0FBQyxJQUFJLEdBQUcsSUFBSSxHQUFHLEVBQUUsQ0FBQyxDQUFBO0lBQ2xELENBQUM7SUFDRCwwQkFBMEI7SUFDMUIsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUE0QjtRQUN4QyxPQUFPLENBQUMsS0FBSyxFQUFFLENBQUE7SUFDakIsQ0FBQztDQUNGLENBQUE7QUFFRCxNQUFNLFdBQVcsR0FBRztJQUNsQixHQUFHLEVBQUUsQ0FBQztJQUNOLEdBQUcsRUFBRSxDQUFDO0NBQ1AsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxVQUFVLENBQUMsV0FBVyxFQUFFLFdBQVcsQ0FBQyxDQUFBIn0=